//import { makeStyles } from '@material-ui/core/styles';
import {Paper} from "@mui/material";
import {Link} from "@mui/material";


const HelpComponent = () =>{
// Formatting of embedded doc is messed up

    return (
    <Paper style={{ minHeight: "auto", height: "100vh", width: "800px", margin:"auto" }} flex={1} overflow="auto">
        <Link href="https://docs.google.com/document/d/1ilhPtGBvBOsjCtxx8HRqITLKh5YFh9IVTP9dp6HMk_Q/export?format=pdf" color="inherit">
            Download PDF
        </Link>
        <iframe title="Zeeno User Guide" style={{border:"none"}}  src="https://drive.google.com/file/d/1KMqj1N5adV3z1YtiGMNxXZEE0HzVBidg/preview" width="100%" height="97%" allow="autoplay"></iframe>
    </Paper>
    )
}

export default HelpComponent
